@switch (type) {
  @case ('default') {
    <ng-template *ngTemplateOutlet="defaultInput"></ng-template>
  }
  @case ('hidden') {
    @if (label) {
      <label class="label" [ngClass]="{ 'text-danger': Error }">{{ label }}</label>
    }
    <div class="text-field size-{{ size }} position-relative">
      @if (!isEdit) {
        <div class="clickable click-css {{ customClass }}" [ngClass]="{ 'text-border': border }" (click)="click()">
          {{ input }}
        </div>
      } @else {
        <ng-template *ngTemplateOutlet="defaultInput"></ng-template>
        <div class="controls-box">
          <button (click)="save()"><app-icon class="align-middle">done</app-icon></button>
          <button (click)="cancel()"><app-icon class="align-middle">close</app-icon></button>
        </div>
      }
    </div>
  }
}

<ng-template #defaultInput>
  <div class="d-flex flex-column">
    @if (label) {
      <label class="label" [ngClass]="{ 'text-danger': Error }"
        >{{ label }}
        @if (required) {
          <span style="color: red">*</span>
        }
      </label>
    }
    <input
      #inputRef
      matInput
      [mask]="mask"
      [placeholder]="placeholder"
      [maxlength]="maxLength"
      autocomplete="off"
      [ngClass]="{ 'disabled-input': disabled, 'error-input': Error }"
      [(ngModel)]="input"
      [disabled]="disabled"
      (ngModelChange)="onchange($event)"
      class="input-default w-100 {{ customClass }}"
    />
  </div>
</ng-template>
